import { useEffect, useState } from 'react';
export function useFileDragDetector(shouldListen = true) {
    const [isDragging, setIsDragging] = useState(false);
    const isDraggingFiles = (event) => { var _a; return (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types.includes('Files'); };
    useEffect(() => {
        const handleDragEnter = (event) => {
            if (isDraggingFiles(event)) {
                setIsDragging(true);
            }
        };
        const handleDragLeave = (event) => {
            if (isDraggingFiles(event)) {
                if (!event.relatedTarget) {
                    setIsDragging(false);
                }
            }
        };
        const handleDrop = (event) => {
            if (isDraggingFiles(event)) {
                setIsDragging(false);
            }
        };
        if (shouldListen) {
            document.addEventListener('dragenter', handleDragEnter);
            document.addEventListener('dragleave', handleDragLeave);
            document.addEventListener('drop', handleDrop);
            return () => {
                document.removeEventListener('dragenter', handleDragEnter);
                document.removeEventListener('dragleave', handleDragLeave);
                document.removeEventListener('drop', handleDrop);
            };
        }
        return undefined;
    }, [shouldListen]);
    return { isDragging };
}
